import { Chains } from 'modules/blockChain/chains'

export const getNativeTokenLabel = (chain: Chains) =>
  chain === Chains.Matic || chain === Chains.Polygon ? 'MATIC' : 'ETH'
